import { useMemo, useState } from 'react';
import { OrderDealType } from 'types';
import { getPriceString } from 'utils/formatters';

import cx from 'classnames';
import styles from './ProductPage.module.scss';
import {NextIcon} from "../../components/NextImage";
import { GearVariantProps } from '../../components/GearVariants/GearVariants';

export type PageGearInfoProps = {
  country: string;
  description: string;
  handleFavoriteButton: () => void;
  handleShareButton: (slug: string) => void;
  hourlyPrice?: number;
  inMyFavorites?: boolean;
  isOwner: boolean;
  isAuth: boolean;
  isAdmin: boolean;
  originalPrice: string | number | undefined;
  price: string | number | undefined;
  currency: string,
  slug: string;
  title: string;
  type: OrderDealType;
};

export const PageGearInfo = ({
  country,
  title,
  price,
  originalPrice,
  currency,
  description,
  type,
  hourlyPrice,
  availableVariants,
  children,
}: PageGearInfoProps) => {
  const [mereDescription, setMoreDescription] = useState(false);

  const handleToggleDescription = () => {
    setMoreDescription((more) => !more);
  };

  const discount = useMemo(() => {
    return Math.ceil(originalPrice ? Math.round((1 - price / originalPrice) * 100) : 0);
  }, [originalPrice, price]);

  return (
    <div className={styles.gearInfo}>
      <h2>{title} {availableVariants?.[0] ? `(${availableVariants[0].options.map(({value}) => value).join(', ')})` : ''}</h2>
      <div className={styles.gearInfoPricing}>
        <div className={styles.gearInfoPrises}>
          <p className={styles.gearInfoPrice}>{getPriceString(price || 0, type === 'rent', hourlyPrice, undefined, undefined, currency)}</p>
          <p className={styles.gearInfoOriginalPrice}>{originalPrice}</p>
          {!!originalPrice && <div className={styles.discountContainer}><p className={styles.discount}>{discount}% OFF</p></div>}
        </div>
        {(country === 'CAN' || country === 'CA') && <NextIcon src="/icons/Maple.svg" size={32} />}
      </div>
      {children}
      <div className={styles.gearInfoDescriptionWrapper}>
        <p className={cx(styles.gearInfoDescription, { [styles.expanded]: mereDescription })}>{description}</p>
        {description.length > 220 && (
          <div className={styles.gearInfoReadMore}>
            <span onClick={handleToggleDescription}>{mereDescription ? 'Read Less' : 'Read More'}</span>
          </div>
        )}
        <p style={{marginTop: 8}} className={styles.gearInfoDescription}>*Currently, SENDY supports the purchase of one item at a time. To keep track of your favorite picks, please mark items as Favorites.</p>
      </div>
    </div>
  );
};
